import { userError } from "@/lib/userError";
import React, { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

export const ConfirmDeleteButton = ({
  title,
  description,
  onConfirm,
  testid,
  ariaLabel = "Poista",
  className,
}) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      setOpen(false);
    } catch (error) {
      toast.error(userError(error, "Poistaminen epäonnistui."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen(true)}
        aria-label={ariaLabel}
        className={cn(
          "min-h-11 min-w-11 rounded-full p-2 text-muted-foreground transition-colors hover:bg-rose-500/10 hover:text-rose-400",
          className,
        )}
      >
        <Trash2 className="h-4 w-4" />
      </button>
      <AlertDialog open={open} onOpenChange={(nextOpen) => !busy && setOpen(nextOpen)}>
        <AlertDialogContent data-testid={`${testid}-dialog`} className="rounded-2xl max-w-sm mx-auto">
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription className="text-left">
              {description}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testid}-cancel`} disabled={busy}>Peruuta</AlertDialogCancel>
            <AlertDialogAction
              data-testid={`${testid}-confirm`}
              onClick={(event) => { event.preventDefault(); confirm(); }}
              disabled={busy}
              className="bg-rose-600 text-white hover:bg-rose-500"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Poista"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
